<div>
  <p>
    {{
      "this_will_import_the_root_configuration_for_the_scaffold_type_set_in_this_instance"
        | translation
    }}
  </p>
  <button nbButton status="primary" (click)="updateConfiguration()">
    Update Config
  </button>
</div>
<nb-accordion>
  <nb-accordion-item>
    <nb-accordion-item-header>
      {{ "configuration_overrides" | translation }}
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <p>
        {{
          "select_the_source_environment_if_you_don't_want_to_use_the_environment_of_this_instance"
            | translation
        }}:
      </p>
      <nb-select placeholder="Select Environment" [(selected)]="source">
        <nb-option value="test">{{'test'|translation}}</nb-option>
        <nb-option value="prod">{{'production'|translation}}</nb-option>
        <nb-option value="">{{'default'|translation}}</nb-option>
      </nb-select>
      <p>
        {{'do_not_use_this_unless_you_are_absolutely_sure_you_have_a_reason_config_lingo'|translation}}
      </p>
      <nb-select placeholder="Select Option" [(selected)]="type">
        <nb-option value="archiving">Archiving</nb-option>
        <nb-option value="archivingv2">Canvas Archiving</nb-option>
        <nb-option value="ai-detection">AI Detection</nb-option>
        <nb-option value="designer">Designer</nb-option>
        <nb-option value="">Default</nb-option>
      </nb-select>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
